import type { BarChartProps, RenderTooltipContentData } from '@shopify/polaris-viz';
import type { IAnalyticMetric } from '~/types/metric';

import { BlockStack, Box, Card, InlineStack, Text } from '@shopify/polaris';
import { GChartProvider } from '../contexts/GChartProvider';
import { numberWithCommas } from '~/modules/analytics';
import { BarChart } from '@shopify/polaris-viz';
import { useTranslation } from 'react-i18next';

export interface GBarChartProps extends BarChartProps {
  tooltipTitle?: string;
  loading?: boolean;
}
export const GBarChart: React.FC<GBarChartProps> = ({
  tooltipTitle,
  tooltipOptions,
  ...barChartProps
}) => {
  // if (loading) return <GSkeletonDisplayText height="323px" />; // TODO: Release 1.2.0 - uncomment this

  return (
    <Box paddingInlineEnd={'300'} paddingInlineStart={'050'}>
      <GChartProvider minHeight={323}>
        <BarChart
          theme="Light"
          renderLegendContent={() => null}
          tooltipOptions={{
            titleFormatter: () => tooltipTitle ?? 'Metric',
            valueFormatter: (value) => numberWithCommas(`${value}`),
            // renderTooltipContent: (data) => <GBarChartTooltip data={data} />,
            ...tooltipOptions,
          }}
          maxSeries={20}
          {...barChartProps}
        />
      </GChartProvider>
    </Box>
  );
};

export interface GBarChartTooltipProps {
  data: RenderTooltipContentData;
  metrics?: IAnalyticMetric[];
  metricsPrevious?: IAnalyticMetric[];
}
// TODO: implement
export const GBarChartTooltip: React.FC<GBarChartTooltipProps> = ({ data }) => {
  const { t } = useTranslation();

  const dataA = data?.data?.[0].data?.[0];
  const dataB = data?.data?.[0].data?.[1];

  // Extract numeric values for comparison
  const valueA = Number(dataA?.value || 0);
  const valueB = Number(dataB?.value || 0);

  return (
    <div className="min-w-[175px] w-fit">
      <Card padding={'200'}>
        <BlockStack gap={'100'}>
          <Text as="p" variant="bodySm" fontWeight="semibold">
            {data.formatters?.titleFormatter?.(data.title || '') || data.title}
          </Text>
          <BlockStack gap={'200'}>
            <InlineStack gap={'200'} align="space-between" blockAlign="center">
              <InlineStack gap={'150'} blockAlign="center">
                <div className="bg-variant-a w-[8px] rounded-[10px] h-[8px]"></div>
                <Text as="p" variant="bodySm" tone="subdued">
                  {t('Control')}
                </Text>
              </InlineStack>
              <InlineStack blockAlign="center" gap="100">
                <Text as="span" variant="headingSm">
                  {valueA}
                </Text>
                {/* <IncreasePercentage increase={increaseA} /> */}
              </InlineStack>
            </InlineStack>

            <InlineStack gap={'200'} align="space-between" blockAlign="center">
              <InlineStack gap={'150'} blockAlign="center">
                <div className="bg-variant-b w-[8px] rounded-[10px] h-[8px]"></div>
                <Text as="p" variant="bodySm" tone="subdued">
                  {t('Variant')}
                </Text>
              </InlineStack>
              <InlineStack blockAlign="center" gap="100">
                <Text as="span" variant="headingSm">
                  {valueB}
                </Text>
                {/* <IncreasePercentage increase={increaseB} /> */}
              </InlineStack>
            </InlineStack>
          </BlockStack>
        </BlockStack>
      </Card>
    </div>
  );
};
